export default __webpack_public_path__ + "static/media/DevWelcome.d0d38d78.png";